import { css } from 'styled-components';
import customCss from '@/app/components/hotel-detail/css/customCss.ts';
import { getListWidth } from '@/app/components/search/components/SearchPageContainer/ListContainer/utils.ts';
import { LISTVIEW_CONTAINER_WIDTH } from '@/app/components/search/styles/constants.ts';
import { isIndexSelector, isListSelector, isMapSelector } from '@/app/common/css/selectors.ts';

const baseStyles = css`
  position: relative;
  z-index: 0;
  box-sizing: border-box;

  @media (min-width: 992px) {
    margin: 0 auto;
  }

  @media ${customCss.breakpoints.lg} {
    padding: 24px 24px 0;
  }

  @media ${customCss.breakpoints.xl} {
    padding: 24px 24px 0;
  }
`;

const indexStyles = css`
  ${isIndexSelector} & {
    ${baseStyles};
    width: 1240px;
    max-width: 100%;

    @media ${customCss.breakpoints.sm} {
      margin: 0 auto;
      max-width: calc(100% - 48px);
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

const mapStyles = css<{ $evolutionResultsOnlyEnabled?: boolean }>`
  ${isMapSelector} & {
    ${baseStyles};
    ${({ $evolutionResultsOnlyEnabled }) => getListWidth(false, $evolutionResultsOnlyEnabled)};

    @media ${customCss.breakpoints.lg} {
      margin: 0;
    }
  }
`;

export const listViewSizing = css`
  box-sizing: border-box;

  ${getListWidth(true)}
  max-width: 100%;
  padding-left: 0;
  padding-right: 0;

  @media ${customCss.breakpoints.sm} {
    margin: 0 16px;
  }

  @media (min-width: 768px) {
    margin: 0 24px;
  }

  @media ${customCss.breakpoints.lg} {
    padding: 24px 24px 0;
    margin: 0 auto;
  }

  @media (min-width: 1152px) {
    padding: 24px 40px 0;
    margin: 0 auto;
  }

  @media ${customCss.breakpoints.xl} {
    padding: 24px 0 0;
    margin-left: calc((100% - ${LISTVIEW_CONTAINER_WIDTH}) / 2);
  }
`;

const listStyles = css`
  ${isListSelector} & {
    ${baseStyles};
    ${listViewSizing};
  }
`;

export const searchPageStyles = css<{ $evolutionResultsOnlyEnabled?: boolean }>`
  ${indexStyles};
  ${listStyles};
  ${mapStyles};
`;
